import { render, staticRenderFns } from "./SmallButton.vue?vue&type=template&id=219b5604&"
import script from "./SmallButton.vue?vue&type=script&lang=ts&"
export * from "./SmallButton.vue?vue&type=script&lang=ts&"
import style0 from "./SmallButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports